export default {
  'All Quota': {
    en: 'All Quota',
    ja: 'All Quota',
    et: 'All Quota',
    lt: 'All Quota',
    ch: 'All Quota',
    ph: 'All Quota',
  },
  'Are you sure you want to delete this quota?': {
    en: 'Are you sure you want to delete this quota?',
    ja: 'Are you sure you want to delete this quota?',
    et: 'Are you sure you want to delete this quota?',
    lt: 'Are you sure you want to delete this quota?',
    ch: 'Are you sure you want to delete this quota?',
    ph: 'Are you sure you want to delete this quota?',
  },
  Country: {
    en: 'Country',
    ja: 'Country',
    et: 'Country',
    lt: 'Country',
    ch: 'Country',
    ph: 'Country',
  },
  'Created Date': {
    en: 'Created Date',
    ja: '作成日',
    et: 'Loomise kuupäev',
    lt: 'Created Date',
    ch: 'Created Date',
    ph: 'Created Date',
  },
  'Danger Zone': {
    en: 'Danger Zone',
    ja: 'Danger Zone',
    et: 'Danger Zone',
    lt: 'Danger Zone',
    ch: 'Danger Zone',
    ph: 'Danger Zone',
  },
  'Delete Quota': {
    en: 'Delete Quota',
    ja: 'Delete Quota',
    et: 'Delete Quota',
    lt: 'Delete Quota',
    ch: 'Delete Quota',
    ph: 'Delete Quota',
  },
  'End Month': {
    en: 'End Month',
    ja: 'End Month',
    et: 'End Month',
    lt: 'End Month',
    ch: 'End Month',
    ph: 'End Month',
  },
  'Event quota created': {
    en: 'Event quota created',
    ja: 'Event quota created',
    et: 'Event quota created',
    lt: 'Event quota created',
    ch: 'Event quota created',
    ph: 'Event quota created',
  },
  'Event quota deleted': {
    en: 'Event quota deleted',
    ja: 'Event quota deleted',
    et: 'Event quota deleted',
    lt: 'Event quota deleted',
    ch: 'Event quota deleted',
    ph: 'Event quota deleted',
  },
  'Event quota edited': {
    en: 'Event quota edited',
    ja: 'Event quota edited',
    et: 'Event quota edited',
    lt: 'Event quota edited',
    ch: 'Event quota edited',
    ph: 'Event quota edited',
  },
  Month: {
    en: 'Month',
    ja: 'Month',
    et: 'Month',
    lt: 'Month',
    ch: 'Month',
    ph: 'Month',
  },
  'New Quota': {
    en: 'New Quota',
    ja: 'New Quota',
    et: 'New Quota',
    lt: 'New Quota',
    ch: 'New Quota',
    ph: 'New Quota',
  },
  'No Results': {
    en: 'No Results',
    ja: '結果がありません',
    et: 'Tulemused puuduvad',
    lt: 'No Results',
    ch: 'No Results',
    ph: 'No Results',
  },
  'Number of weekdays allocated cannot be less than 0.': {
    en: 'Number of weekdays allocated cannot be less than 0.',
    ja: 'Number of weekdays allocated cannot be less than 0.',
    et: 'Number of weekdays allocated cannot be less than 0.',
    lt: 'Number of weekdays allocated cannot be less than 0.',
    ch: 'Number of weekdays allocated cannot be less than 0.',
    ph: 'Number of weekdays allocated cannot be less than 0.',
  },
  'Number of weekends allocated cannot be less than 0.': {
    en: 'Number of weekends allocated cannot be less than 0.',
    ja: 'Number of weekends allocated cannot be less than 0.',
    et: 'Number of weekends allocated cannot be less than 0.',
    lt: 'Number of weekends allocated cannot be less than 0.',
    ch: 'Number of weekends allocated cannot be less than 0.',
    ph: 'Number of weekends allocated cannot be less than 0.',
  },
  'Quota Data': {
    en: 'Quota Data',
    ja: 'Quota Data',
    et: 'Quota Data',
    lt: 'Quota Data',
    ch: 'Quota Data',
    ph: 'Quota Data',
  },
  Quotas: {
    en: 'Quotas',
    ja: 'Quotas',
    et: 'Quotas',
    lt: 'Quotas',
    ch: 'Quotas',
    ph: 'Quotas',
  },
  Save: {
    en: 'Save',
    ja: '保存',
    et: 'Salvesta',
    lt: 'Save',
    ch: 'Save',
    ph: 'Save',
  },
  'Start Month': {
    en: 'Start Month',
    ja: 'Start Month',
    et: 'Start Month',
    lt: 'Start Month',
    ch: 'Start Month',
    ph: 'Start Month',
  },
  'Updated Date': {
    en: 'Updated Date',
    ja: '編集された日付',
    et: 'Muutmise kuupäev',
    lt: 'Updated Date',
    ch: 'Updated Date',
    ph: 'Updated Date',
  },
  'Weekday Quota': {
    en: 'Weekday Quota',
    ja: 'Weekday Quota',
    et: 'Weekday Quota',
    lt: 'Weekday Quota',
    ch: 'Weekday Quota',
    ph: 'Weekday Quota',
  },
  Weekdays: {
    en: 'Weekdays',
    ja: '平日',
    et: 'Argipäevad',
    lt: 'Weekdays',
    ch: 'Weekdays',
    ph: 'Weekdays',
  },
  'Weekend Quota': {
    en: 'Weekend Quota',
    ja: 'Weekend Quota',
    et: 'Weekend Quota',
    lt: 'Weekend Quota',
    ch: 'Weekend Quota',
    ph: 'Weekend Quota',
  },
  Weekends: {
    en: 'Weekends',
    ja: '週末',
    et: 'Nädalavahetused',
    lt: 'Weekends',
    ch: 'Weekends',
    ph: 'Weekends',
  },
  Year: {
    en: 'Year',
    ja: 'Year',
    et: 'Year',
    lt: 'Year',
    ch: 'Year',
    ph: 'Year',
  },
  'create the same quota for multiple months?': {
    en: 'create the same quota for multiple months?',
    ja: 'create the same quota for multiple months?',
    et: 'create the same quota for multiple months?',
    lt: 'create the same quota for multiple months?',
    ch: 'create the same quota for multiple months?',
    ph: 'create the same quota for multiple months?',
  },
  January: {
    en: 'January',
    ja: '一月',
    et: 'Jaanuar',
    lt: 'January',
    ch: 'January',
    ph: 'January',
  },
  February: {
    en: 'February',
    ja: '二月',
    et: 'Veebruar',
    lt: 'February',
    ch: 'February',
    ph: 'February',
  },
  March: {
    en: 'March',
    ja: '三月',
    et: 'Märts',
    lt: 'March',
    ch: 'March',
    ph: 'March',
  },
  April: {
    en: 'April',
    ja: '４月',
    et: 'Aprill',
    lt: 'April',
    ch: 'April',
    ph: 'April',
  },
  May: {
    en: 'May',
    ja: '５月',
    et: 'Mai',
    lt: 'May',
    ch: 'May',
    ph: 'May',
  },
  June: {
    en: 'June',
    ja: '６月',
    et: 'Juuni',
    lt: 'June',
    ch: 'June',
    ph: 'June',
  },
  July: {
    en: 'July',
    ja: '７月',
    et: 'Juuli',
    lt: 'July',
    ch: 'July',
    ph: 'July',
  },
  August: {
    en: 'August',
    ja: '８月',
    et: 'August',
    lt: 'August',
    ch: 'August',
    ph: 'August',
  },
  September: {
    en: 'September',
    ja: '９月',
    et: 'September',
    lt: 'September',
    ch: 'September',
    ph: 'September',
  },
  October: {
    en: 'October',
    ja: '１０月',
    et: 'Oktoober',
    lt: 'October',
    ch: 'October',
    ph: 'October',
  },
  November: {
    en: 'November',
    ja: '１１月',
    et: 'November',
    lt: 'November',
    ch: 'November',
    ph: 'November',
  },
  December: {
    en: 'December',
    ja: '１２月',
    et: 'Detsember',
    lt: 'December',
    ch: 'December',
    ph: 'December',
  },
};
